export const ACHIVEMENT_PERCENT = ["20", "40", "60", "80", "100"];
